import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Settings } from '../core';
import { deserialize } from 'santee-dcts';
import { AnnouncementsReadModel, Announcement } from './announcement';
import { Observable } from 'rxjs';
import { map, publishLast, refCount } from 'rxjs/operators';

@Injectable()
export class AnnouncementsStorage {
    private readonly announcements: Observable<Announcement[]>;

    constructor(private http: HttpClient, private settings: Settings) {
        this.announcements = this.loadAll()
            .pipe(
                publishLast(),
                refCount()
            );
    }

    public get all(): Observable<Announcement[]> {
        return this.announcements;
    }

    private loadAll() {
        return this.http.get(`${this.settings.apiUrl}/announcements/all`)
            .pipe(map((response) => deserialize(response, AnnouncementsReadModel).announcements));
    }
}